import { CommonModule } from '@angular/common';
import {
  Component,
  type ComponentRef,
  ViewChild,
  ViewContainerRef,
  effect,
  inject,
  input,
} from '@angular/core';
import { Message, Notification } from '@clean-code/models';
import {
  NotificationHostDirective,
  NotificationService,
} from '@clean-code/notifications/domain';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faEnvelopeOpen } from '@fortawesome/pro-solid-svg-icons';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
    selector: 'notifications-notification-host',
    templateUrl: './notification-host.component.html',
    styleUrls: ['./notification-host.component.scss'],
    imports: [
        CommonModule,
        TranslocoModule,
        FontAwesomeModule,
        NotificationHostDirective,
    ]
})
export class NotificationHostComponent {
  private viewContainerRef = inject(ViewContainerRef);
  private notificationSerivce = inject(NotificationService);

  public notification = input.required<Message>();

  @ViewChild(NotificationHostDirective, { static: true })
  public notificationHost: NotificationHostDirective;

  public componentRef: ComponentRef<Notification>;

  public faEnvelopeOpen = faEnvelopeOpen;

  constructor() {
    effect(() => {
      const notification = this.notification();
      if (notification) {
        this.loadComponent(notification);
      }
    });
  }

  private loadComponent(notification: Message): void {
    const notificationType = this.notificationSerivce.getNotificationType(
      notification.type,
    );
    if (!notificationType) {
      return;
    }

    const viewContainerRef = this.notificationHost.viewContainerRef;
    viewContainerRef.clear();

    this.componentRef = this.viewContainerRef.createComponent(notificationType);
    this.componentRef.setInput('message', this.notification());
  }

  public notificationClicked($event: Event) {
    this.componentRef.instance.itemClicked($event);
  }

  public markMessageAsRead($event: Event) {
    $event.stopPropagation();
    $event.preventDefault();

    const notification = this.notification();
    if (notification) {
      this.notificationSerivce.setNotificationRead(notification.id);
    }
  }
}
